import React from "react"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { NirvanaBreathingLoaderElement } from "@front-shared/elements/nirvanaBreathingLoader.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import type { IEraUploadUploadProgress } from "../../../types/integrations.types"

export const EraUploadUploadProgressOverlayComponent: React.FunctionComponent<
    IEraUploadUploadProgressOverlayComponentProps
> = props => {
    if (!props.isActive || !props.progress) {
        return null
    }

    const { uploadedCount, totalCount } = props.progress

    const progressLabel =
        totalCount === 1
            ? "Uploading your file..."
            : `${uploadedCount} of ${totalCount} files uploaded`

    return (
        <>
            <NirvanaBreathingLoaderElement isActive ignoreText />

            <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[301] w-full max-w-[480px] px-[24px]">
                <PrimaryText centered typography="h4" weight="semibold">
                    Upload in progress
                </PrimaryText>

                <PrimaryText
                    className="mt-[12px]"
                    centered
                    typography="subtitle"
                    color={NIRVANA_COLORS.brand.grey7}
                >
                    {progressLabel}
                </PrimaryText>

                {totalCount > 1 && uploadedCount < totalCount ? (
                    <PrimaryText
                        className="mt-[8px]"
                        centered
                        size={13}
                        lineHeight={18}
                        color={NIRVANA_COLORS.brand.grey7}
                    >
                        Please keep this tab open until all files finish
                        uploading.
                    </PrimaryText>
                ) : null}
            </div>
        </>
    )
}

interface IEraUploadUploadProgressOverlayComponentProps {
    isActive: boolean
    progress: IEraUploadUploadProgress | null
}
